import { clientModel } from "../../client/api/types";
import { ProductListModel } from "../../products/api/types";
import { UserModel } from "../../users-facility/api/types";
import { create } from "zustand";
import { persist } from "zustand/middleware";

export interface IMainState {
  currentUser: UserModel | undefined;
  clientsAnchorEl: null | HTMLElement;
  selectedClient: clientModel | undefined;
  setSelectedClient: (client: clientModel | undefined) => void;
  setClientsAnchorEl: (clientsAnchorEl: null | HTMLElement) => void;
  setCurrentUser: (user: UserModel | undefined) => void;
  initialProductState: ProductListModel;
  lastSelectedClientInFacility?: clientModel;
  setLastSelectedClientInFacility?: (client: clientModel) => void;
}

const useMainStore = create<IMainState>()(
  persist(
    (set, get) => ({
      currentUser: undefined,
      clientsAnchorEl: null,
      selectedClient: undefined,
      setSelectedClient: (client) => {
        const currentPath = window.location.pathname;
        const isFacilitiesRoute = currentPath.includes("/facilities");
        const currentClient = get().selectedClient;

        if (
          isFacilitiesRoute &&
          currentClient?.id &&
          currentClient.id.trim() !== ""
        ) {
          set({
            selectedClient: client,
            lastSelectedClientInFacility: currentClient,
          });
        } else {
          set({ selectedClient: client });
        }
      },
      setClientsAnchorEl: (clientsAnchorEl) => set({ clientsAnchorEl }),
      setCurrentUser: (user) => set({ currentUser: user }),

      lastSelectedClientInFacility: undefined,
      setLastSelectedClientInFacility: (client) =>
        set({ lastSelectedClientInFacility: client }),

      initialProductState: {
        items: [],
        totalItem: 0,
        pageNumber: 1,
        pageSize: 10,
        searchText: undefined,
        onlyActive: true,
      },
    }),
    {
      name: "main-store",
      partialize: (state) => ({
        currentUser: state.currentUser,
        selectedClient: state.selectedClient,
      }),
    }
  )
);

export default useMainStore;
